import { Badge, Box, Flex, Text, Tooltip } from '@chakra-ui/react';
import {
  faShieldCheck,
  faTriangleExclamation
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EMAIL_DELIVERY_STATUS_MAP } from '@publishing-engine/domain/models';
import {
  EMAIL_DELIVERY_ICON_MAP,
  EmailDeliveryStatus,
  emailStatusTooltipMap,
  formatLocalTimestamp
} from './EmailView';

type UserNameProps = {
  firstName?: string;
  middleName?: string;
  lastName?: string;
  tooltipLabel?: string;
  isEmailDelivered?: boolean;
  lastSentStatus?: string;
  enableIcon?: boolean;
  isActionLabel?: boolean;
  timeStamp?: string | number | undefined;
  isUserDeactivated?: boolean;
};

const UserName: React.FC<UserNameProps> = ({
  firstName,
  middleName,
  lastName,
  tooltipLabel = 'View Author Profile',
  isEmailDelivered,
  lastSentStatus,
  enableIcon = false,
  isActionLabel = true,
  timeStamp,
  isUserDeactivated = false
}) => {
  const fullName = [firstName, middleName, lastName].filter(Boolean).join(' ');

  if (!fullName) return null;

  const deliveryIcon = lastSentStatus
    ? EMAIL_DELIVERY_ICON_MAP[lastSentStatus as EmailDeliveryStatus]
    : undefined;
  const deliveryIconColor = lastSentStatus
    ? EMAIL_DELIVERY_STATUS_MAP[lastSentStatus as EmailDeliveryStatus]
    : undefined;
  const lastSentEmailTimeFormatted = timeStamp
    ? formatLocalTimestamp(Number(timeStamp) * 1000)
    : undefined;
  const emailStatusTooltip = lastSentStatus
    ? emailStatusTooltipMap[lastSentStatus]
    : undefined;

  return (
    <Flex gap={2} alignItems="center" minWidth={0}>
      {isActionLabel ? (
        <Tooltip hasArrow borderRadius={4} placement="top" label={tooltipLabel}>
          <Text
            textStyle="actionLabel"
            textDecoration="none"
            whiteSpace="normal"
            maxWidth="120px"
            isTruncated
            color="actionPrimaryFill"
            _hover={{
              textDecoration: 'underline',
              textDecorationColor: 'actionPrimaryFill'
            }}
          >
            {fullName}
          </Text>
        </Tooltip>
      ) : (
        <Text
          textStyle="actionLabel"
          whiteSpace="normal"
          isTruncated
          maxWidth="120px"
        >
          {fullName}
        </Text>
      )}

      {isUserDeactivated === false && (
        <>
          {enableIcon && (
            <>
              {isEmailDelivered ? (
                <Tooltip
                  placement="top"
                  label={` Email verified`}
                  shouldWrapChildren
                >
                  <Badge variant="success">
                    <FontAwesomeIcon icon={faShieldCheck} />
                  </Badge>
                </Tooltip>
              ) : (
                <Tooltip
                  placement="top"
                  label={`Email Unverified`}
                  shouldWrapChildren
                >
                  <Badge variant="attention">
                    <FontAwesomeIcon icon={faTriangleExclamation} />
                  </Badge>
                </Tooltip>
              )}
            </>
          )}

          {lastSentStatus && deliveryIcon && (
            <Box>
              <Tooltip
                placement="top"
                label={`${emailStatusTooltip}  : ${lastSentEmailTimeFormatted}`}
                shouldWrapChildren
              >
                <Badge size="context" variant={deliveryIconColor}>
                  <FontAwesomeIcon icon={deliveryIcon} />
                </Badge>
              </Tooltip>
            </Box>
          )}
        </>
      )}
    </Flex>
  );
};

export default UserName;
